import { render } from "./DepartSelect.vue?vue&type=template&id=691b9a43"
import script from "./DepartSelect.vue?vue&type=script&lang=js"
export * from "./DepartSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/h5/data/DepartSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "691b9a43"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('691b9a43', __exports__)) {
    api.reload('691b9a43', __exports__)
  }
  
  module.hot.accept("./DepartSelect.vue?vue&type=template&id=691b9a43", () => {
    api.rerender('691b9a43', render)
  })

}


export default __exports__